import React, { useState, useEffect } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Spinner
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { isAdmin } from 'components/shared/helpers/auth';
import { apiRequest } from 'helpers/apiClient';

import './Register.scss';

export const Register: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('user');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin()) {
      navigate('/');
    }
  }, []);

  const handleChange = (e: any): void => {
    const { name, value } = e.target;
    switch (name) {
      case 'email':
        setEmail(value);
        break;
      case 'password':
        setPassword(value);
        break;
      default:
        break;
    }
  };

  const handleRegister = async (): Promise<void> => {
    setLoading(true);
    try {
      await apiRequest('auth/users', {
        method: 'POST',
        body: JSON.stringify({ email, password, role })
      });
      alert('Successfully registered user');
      navigate('/');
    } catch (error: any) {
      alert(error?.message || 'There was an error, please try again');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='signIn' data-testid='register-page'>
      <h3>Register</h3>
      <FormControl display={'flex'} gap={3} mb={5}>
        <FormLabel w={110}>Email:</FormLabel>
        <Input
          type='email'
          name='email'
          onChange={handleChange}
          data-testid='register-email'
        />
      </FormControl>
      <FormControl display={'flex'} gap={3} mb={5}>
        <FormLabel w={110}>Password:</FormLabel>
        <Input
          type='password'
          name='password'
          onChange={handleChange}
          data-testid='register-password'
        />
      </FormControl>
      <FormControl display={'flex'} gap={3} mb={5}>
        <FormLabel w={85}>Admin:</FormLabel>
        <Checkbox
          data-testid='register-admin'
          onChange={(e: any) => {
            setRole(`${e.target.checked ? 'admin' : 'user'}`);
          }}
        />
      </FormControl>

      <div className='submit'>
        {loading ? (
          <Spinner />
        ) : (
          <Button
            p={'10px 30px'}
            data-testid='register-submit'
            onClick={() => {
              void handleRegister();
            }}
          >
            Register
          </Button>
        )}
      </div>
    </div>
  );
};
